<!-- 
	This is the dashboard page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
	<div>
		<!-- Counter Widgets -->
		<a-row :gutter="24" class="head-content">
			<div class="mb-24 head-item" v-for="(stat, index) in stats" :key="index">
				<!-- Widget 1 Card -->
				<WidgetCounter :title="stat.title" :value="stat.value" :prefix="stat.prefix" :suffix="stat.suffix"
					:icon="stat.icon" :status="stat.status" style="height: 100%;cursor: pointer;" @onClick="onClick">
				</WidgetCounter>
				<!-- / Widget 1 Card -->
			</div>
		</a-row>
		<!-- / Counter Widgets -->

		<!-- Charts -->
		<a-row :gutter="24" type="flex" align="stretch">
			<a-col :span="24" :lg="12" class="mb-24">

				<!-- Active Users Card -->
				<CardBarChart :barChartData="barChartData" :yesterShoukuan="yesterShoukuan"
					:todayShouwkuan="todayShouwkuan"></CardBarChart>
				<!-- Active Users Card -->

			</a-col>
			<a-col :span="24" :lg="12" class="mb-24">

				<!-- Sales Overview Card -->
				<CardLineChart :lineChartData="lineChartData" :todayTotalCountDatas="todayTotalCountDatas"
					@changedate="changedate">
				</CardLineChart>
				<!-- / Sales Overview Card -->

			</a-col>
		</a-row>
		<!-- / Charts -->

		<!-- Table & Timeline -->
		<!-- <a-spin :indicator="() => null" tip="开发中"> -->
		<a-row :gutter="24" type="flex" align="stretch">
			<!-- Table -->
			<a-col :span="24" :lg="24" class="mb-24">

				<!-- Projects Table Card -->
				<CardProjectTable :data="tableData" :columns="tableColumns" @changeday="changeday"
					:dayloading="dayloading"></CardProjectTable>
				<!-- / Projects Table Card -->

			</a-col>
			<!-- / Table -->

			<!-- Timeline -->
			<!-- <a-col :span="24" :lg="8" class="mb-24">
				<CardOrderHistory></CardOrderHistory>
			</a-col> -->
			<!-- / Timeline -->
		</a-row>
		<!-- </a-spin> -->
		<!-- / Table & Timeline -->

		<!-- Cards -->
		<!-- <a-row :gutter="24" type="flex" align="stretch">
			<a-col :span="24" :xl="14" class="mb-24">

				<CardInfo></CardInfo>

			</a-col>
			<a-col :span="24" :xl="10" class="mb-24">

				<CardInfo2></CardInfo2>

			</a-col>
		</a-row> -->
		<!-- / Cards -->
		<a-modal v-model="visible1" title="今日入会" :footer="null" width="876px">
			<a-table :columns='[
				{
					title: "姓名", dataIndex: "customer_name", scopedSlots: { customRender: "customer_name" }, width: 150,
				}, { title: "手机号", dataIndex: "customer_phone", width: 160, }, {
					title: "是否签署会员合同",
					dataIndex: "contract", customRender: (text) => text == 1 ? "已签署" : "未签署", width: 160
				},
				, {
					title: "会员等级"
					, dataIndex: "memberChildren", scopedSlots: { customRender: "memberChildren" }, width: 200
				}, {
					title: "身份证号", dataIndex: "id_no", width: 200
				}, {
					title: "性别", dataIndex: "gender_text", width: 80
				}, { title: "创建时间", dataIndex: "create_time", width: 200 }]' :data-source="visible1Table" :pagination="false"
				:scroll="{ y: 400, x: 1200 }">
				<template slot="memberChildren" slot-scope="memberChildren">
					<div v-if="memberChildren.length > 0">
						<a-tag color="blue" v-for="v in memberChildren">{{ v.vip_key }}</a-tag>
					</div>
					<a-tag color="red" v-else>未入会</a-tag>
				</template>
			</a-table>
		</a-modal>
		<a-modal v-model="visible2" title="今日出行客户行程" :footer="null" width="876px">
			<tripTable :x="1200" :y="440" :columns='[
				{
					title: "合计总费用",
					dataIndex: "price_total_all", width: 120
				},
				{
					title: "行程名称", dataIndex: "trip_name", width: 200
				}, {
					title: "出行次数", dataIndex: "playindextext", width:
						100, scopedSlots: { customRender: "playindextext" },
				}, {
					title: "行程人数", dataIndex: "person_length",
					width: 100, customRender: (text) => `${text}人`,
				},
				{
					title: "今天是出行",
					dataIndex: "trip_days2",
					scopedSlots: { customRender: "trip_days2" },
					width: 120,
				},
				{
					title: "行程天数",
					dataIndex: "trip_days",
					width: 150,
					customRender: (text) => text.split(",")[0] + "至" + text.split(",")[text.split(",").length - 1],
				}, { title: "合计利润", dataIndex: "profit_total_all", width: 100 },]' :dataList="visible2Table"
				:dataListLoading="visible2loading">
			</tripTable>
		</a-modal>
	</div>
</template>

<script>
import moment from 'moment'
import tripTable from '@/components/TripProject/tripTable.vue'

// Bar chart for "Active Users" card.
import CardBarChart from '../components/Cards/CardBarChart';

// Line chart for "Sales Overview" card.
import CardLineChart from '../components/Cards/CardLineChart';

// Counter Widgets
import WidgetCounter from '../components/Widgets/WidgetCounter';

// "Projects" table component.
import CardProjectTable from '../components/Cards/CardProjectTable';

// Order History card component.
import CardOrderHistory from '../components/Cards/CardOrderHistory';

// Information card 1.
import CardInfo from '../components/Cards/CardInfo';

// Information card 2.
import CardInfo2 from '../components/Cards/CardInfo2';
// Counter Widgets stats
const stats = [
	{
		title: "我的会员数",
		value: 0,
		// prefix: "1",
		suffix: "",
		icon: `<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
							<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
							<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
							<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
						</svg>`,
	},
	{
		title: "今日入会数量",
		value: 0,
		prefix: "+",
		suffix: "",
		icon: `<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z" fill="#111827"/>
						</svg>`,
	},
	{
		title: "今日出行客户量",
		value: 0,
		prefix: "",
		suffix: "",
		icon: `<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z" fill="#111827"/>
						</svg>`,
	},
	{
		title: "今日制作行程总数量",
		value: 0,
		prefix: "",
		status: "", //success danger
		suffix: "",
		icon: `<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z" fill="#111827"/>
						</svg>`,
	},
	{
		title: "今日出行销售价",
		value: 0,
		prefix: "¥",
		// suffix: "+10%",
		icon: `<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z" fill="#111827"/>
							<path d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z" fill="#111827"/>
							<path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z" fill="#111827"/>
						</svg>`,
	},
];

// "Projects" table list of columns and their properties.
const tableColumns = [
	{
		title: '日期',
		dataIndex: 'day',
		scopedSlots: { customRender: 'day' },
		width: 200,
	},
	{
		title: '转化率',
		scopedSlots: { customRender: 'conversionrate' },
		dataIndex: 'conversionrate',
	},
	// {
	// 	title: 'MEMBERS',
	// 	dataIndex: 'members',
	// 	scopedSlots: { customRender: 'members' },
	// },
	{
		title: '入私域人数',
		dataIndex: 'domaincount',
		customRender: (text) => (text ?? 0) + '人'
		// class: 'font-bold text-muted text-sm',
	},
	{
		title: "三亚咨询数量",
		dataIndex: "sanyaallcount",
	},
	{
		title: "三亚成交数量",
		dataIndex: "sanyacount",
	},
	{
		title: "澳门咨询数量",
		dataIndex: "aomenallcount",
	},
	{
		title: "澳门成交数量",
		dataIndex: "aomencount",
	},

];

// "Projects" table list of rows and their properties.
const tableData = [
	{
		key: '1',
		company: {
			name: 'Soft UI Shopify Version',
			logo: 'images/logos/logo-shopify.svg',
		},
		members: ["images/face-1.jpg", "images/face-4.jpg", "images/face-2.jpg", "images/face-3.jpg",],
		budget: '$14,000',
		completion: 60,
	},
	{
		key: '2',
		company: {
			name: 'Progress Track',
			logo: 'images/logos/logo-atlassian.svg',
		},
		members: ["images/face-4.jpg", "images/face-3.jpg",],
		budget: '$3,000',
		completion: 10,
	},
	{
		key: '3',
		company: {
			name: 'Fix Platform Errors',
			logo: 'images/logos/logo-slack.svg',
		},
		members: ["images/face-1.jpg", "images/face-2.jpg", "images/face-3.jpg",],
		budget: 'Not Set',
		completion: {
			label: '100',
			status: 'success',
			value: 100,
		},
	},
	{
		key: '4',
		company: {
			name: 'Launch new Mobile App',
			logo: 'images/logos/logo-spotify.svg',
		},
		members: ["images/face-1.jpg", "images/face-2.jpg",],
		budget: '$20,600',
		completion: {
			label: '100',
			status: 'success',
			value: 100,
		},
	},
	{
		key: '5',
		company: {
			name: 'Add the New Landing Page',
			logo: 'images/logos/logo-jira.svg',
		},
		members: ["images/face-1.jpg", "images/face-4.jpg", "images/face-2.jpg", "images/face-3.jpg",],
		budget: '$4,000',
		completion: 80,
	},
	{
		key: '6',
		company: {
			name: 'Redesign Online Store',
			logo: 'images/logos/logo-invision.svg',
		},
		members: ["images/face-1.jpg", "images/face-4.jpg", "images/face-3.jpg",],
		budget: '$2,000',
		completion: {
			label: 'Cancelled',
			status: 'exception',
			value: 100,
		},
	},
];

export default ({
	components: {
		CardBarChart,
		CardLineChart,
		WidgetCounter,
		CardProjectTable,
		CardOrderHistory,
		CardInfo,
		CardInfo2,
		tripTable
	},
	data() {
		return {

			// Associating table data with its corresponding property.
			tableData: [],

			// Associating table columns with its corresponding property.
			tableColumns,

			// Counter Widgets Stats
			stats,
			barChartData: {
				labels: ['1', '2', '3', '4', '5', '6'],
				datasets: [{
					label: '入账',
					backgroundColor: '#fff',
					borderWidth: 0,
					borderSkipped: false,
					borderRadius: 6,
					data: [0, 0, 0, 0, 0, 0],
					maxBarThickness: 20,
				}],
			},
			yesterShoukuan: 0,
			todayShouwkuan: 0,
			lineChartData: {
				labels: ["--", "--", "--"],
				datasets: [{
					label: "行程总数量",
					tension: 0.4,
					borderWidth: 0,
					pointRadius: 0,
					borderColor: "#1890FF",
					borderWidth: 3,
					data: [0, 0, 0],
					maxBarThickness: 6

				},
				{
					label: "有效成交",
					tension: 0.4,
					borderWidth: 0,
					pointRadius: 0,
					borderColor: "#B37FEB",
					borderWidth: 3,
					data: [0, 0, 0],
					maxBarThickness: 6
				}],
			},
			todayTotalTripsDatas: "",
			todayTotalCountDatas: "",
			daylimit: '7',
			dayloading: false,
			visible1: false,
			visible1Table: [],
			visible2: false,
			visible2Table: [],
			visible2loading: false
		}
	},
	methods: {
		onClick(t) {
			console.log(t)
			if (t == '今日入会数量') {
				this.visible1 = true
			}
			if (t == '今日出行客户量') {
				this.visible2 = true
				this.getvisible2data()
			}
		},
		getvisible2data() {
			if (this.visible2loading) return
			this.visible2loading = true
			const trip_days = moment().format('YYYY-MM-DD')
			this.$http({
				url: '/admin/finance/page?page=1&limit=500&trip_days=' + trip_days,
				method: 'get',
			}).then(res => {
				console.log(res, '获取今日出行客户量数据成功')
				this.visible2Table = res.data.result
			}).finally(()=>{
				this.visible2loading = false
			})
		},
		changedate(e) {
			console.log(e)
			this.getChengjiao({ start: e[0], end: e[1] })
		},
		changeday(daylimit) {
			this.daylimit = daylimit
			this.getDomain()
		},
		getDomain() {
			this.dayloading = true
			setTimeout(() => {
				this.$http({
					url: '/admin/domain/page?page=1&limit=' + this.daylimit,
					method: 'get',
				}).then(res => {
					this.tableData = res.data.result
				}).finally(() => this.dayloading = false)
			}, 200);
		},
		//获取成交订单数据
		getChengjiao(data) {
			this.$http({
				url: '/admin/dashboard/chengjiao?' + (data ? 'start=' + data.start + '&end=' + data.end : ''),
				method: 'get'
			}).then(res => {
				this.lineChartData = {
					labels: res.data.totalTripsLabels,
					datasets: [{
						label: "行程总数量",
						tension: 0.4,
						borderWidth: 0,
						pointRadius: 0,
						borderColor: "#1890FF",
						borderWidth: 3,
						data: res.data.totalTripsDatas,
						maxBarThickness: 6

					},
					{
						label: "有效成交",
						tension: 0.4,
						borderWidth: 0,
						pointRadius: 0,
						borderColor: "#B37FEB",
						borderWidth: 3,
						data: res.data.totalCountDatas,
						maxBarThickness: 6
					}],
				}
				this.todayTotalTripsDatas = res.data.todayTotalTripsDatas
				this.todayTotalCountDatas = res.data.todayTotalCountDatas
			})
		},
	},
	mounted() {
		this.$http({
			url: '/admin/dashboard/home',
			method: 'get'
		}).then(res => {
			this.stats[0].value = res.data.allPersonCount
			this.stats[0].suffix = res.data.allSysPersonCount
			this.stats[1].value = res.data.allPersonCountToday.count
			this.visible1Table = res.data.allPersonCountToday.rows
			this.stats[2].value = res.data.todayTrip
			// this.visible2Table = res.data.todayTrip.rows
			this.stats[3].value = res.data.allTripCountToday
			this.stats[4].value = parseFloat(res.data.allTripprojectToday) || 0
		})
		this.$http({
			url: '/admin/dashboard/shoukuan',
			method: 'get'
		}).then(res => {
			this.barChartData = {
				labels: res.data.monthLabels.map(v => v.title),
				datasets: [{
					label: '收款',
					backgroundColor: '#fff',
					borderWidth: 0,
					borderSkipped: false,
					borderRadius: 6,
					data: res.data.monthLabels.map(v => v.totalAmount),
					maxBarThickness: 20,
				}],
			}
			this.yesterShoukuan = res.data.yesterTotalAmount
			this.todayShouwkuan = res.data.todayTotalAmount
		})
		this.getDomain()
	}
})

</script>

<style lang="scss">
.head-content {
	display: flex;
	justify-content: space-evenly;
	flex-wrap: wrap;

	.head-item {
		width: calc(20% - 10px);
	}

	@media screen and (max-width: 1180px) {
		.head-item {
			width: calc(50% - 10px);
		}
	}

	@media screen and (max-width: 576px) {
		.head-item {
			width: 100%;
		}
	}
}
</style>